import { useEffect, useState } from "react";
import type { DesiredTone, EmojiPreference, Mode } from "../types/api";

export type Preferences = {
  mode: Mode;
  contextOpen: boolean;
  desiredTone: DesiredTone;
  emojiPreference: EmojiPreference;
};

const DEFAULTS: Preferences = {
  mode: "behavior",
  contextOpen: false,
  desiredTone: "keep_voice",
  emojiPreference: "auto"
};

const KEY = "unc-check-prefs-v1";

function readPreferences(): Preferences {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<Preferences>;
    return {
      mode: parsed.mode === "communication" ? "communication" : "behavior",
      contextOpen: Boolean(parsed.contextOpen),
      desiredTone: parsed.desiredTone || DEFAULTS.desiredTone,
      emojiPreference: parsed.emojiPreference || DEFAULTS.emojiPreference
    };
  } catch {
    return DEFAULTS;
  }
}

export function useLocalPreferences() {
  const [preferences, setPreferences] = useState<Preferences>(() =>
    typeof window === "undefined" || !window.localStorage ? DEFAULTS : readPreferences()
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(KEY, JSON.stringify(preferences));
  }, [preferences]);

  return [preferences, setPreferences] as const;
}
